export enum AutocompleteTypesEnum {
    CONTACT,
    CONCIERGE,
    TICKET
}